module.exports = __webpack_public_path__ + "static/img/lotteryLogo.ec7b347.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lotteryLogo.png
// module id = EKEA
// module chunks = 0